/* Plantica — the footer's link columns

   The columns are `<details open>` in the markup, so a wide screen needs
   nothing from here: they are simply open, and the stylesheet takes away the
   rule, the plus and the pointer above 750px.

   On a phone this closes them, which is the only thing it does. Written that
   way round on purpose: with the script blocked, a phone shows every column
   open — the footer as it was, long but whole — rather than four rows that
   cannot be opened.

   Reopened when the screen grows, so a visitor who rotates a tablet does not
   find the columns collapsed where they should be open. */

(() => {
  const PHONE = '(max-width: 749px)';
  const query = window.matchMedia(PHONE);

  const apply = () => {
    const phone = query.matches;
    document.querySelectorAll('.plantica-footer__menu').forEach((menu) => {
      // Only the width decides here; on a phone the visitor decides after this.
      menu.open = !phone;
    });
  };

  apply();
  query.addEventListener('change', apply);
})();
